var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('AppSelectBox',_vm._g(_vm._b({attrs:{"label":"شرط","items":_vm.def,"item-text":_vm.$t,"item-value":"condition"}},'AppSelectBox',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }